export const data = [
    {
        id: "0",
        question: "What is the difference between brushless and brushed motors?",
        answer: "Brushless motors are more efficient.",
        variants: [`Brushless motors make no sound.`, `Brushless motors don't use magnets.`, `Brushless motors are cheaper.`, `Brushless motors are more efficient.`]
    },
    {
        id: "1",
        question: "What is the best motor available to FRC teams in terms of power and efficiency?",
        answer: "Falcon 500",
        variants: [`Falcon 500`, `Neo`, `775 pro`, `Neo 550`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },